export default __webpack_public_path__ + "static/media/scan-bunifikasi-logotype-d.49a94783.svg";